import {get, post, del, patch, download} from "../api"
import * as url from "../url"

const apiPostSearchList = data => {
  return post(url.API_SEARCH + "search/", data.history, data.data)
}

const apiDownloadSearchDownload = data => {
  return download(url.API_FILES + "download/" + data.sign, data.history, data.filename)
}

export {
  apiPostSearchList,
  apiDownloadSearchDownload,
}
